<ng-container *ngIf="isAuthenticated">
  <div class="footer">
    <!-- <div class="footer-top"  [style.background-color] = "themeService.applyCustomTheme('footerTopBG')"> -->
    <div class="footer-top" appCheckTheme="footer">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="d-flex">
              <div class="first-top-footer mr-auto">
                <h5>
                  Enterprise Automation Fabric
                </h5>
                <div class="left-top-footer-link">
                  <!-- <a href="#">Tickets </a>
                <a href="#">Oversight </a>
                <a href="#">Predictions </a>
                <a href="#">Monitor </a>
                <a href="#">Solutions </a>
                <a href="#">Analysis </a>
                <a href="#">Orchestrator </a>
                <a href="#">Scripts </a> -->
                </div>
              </div>
              <div class="second-top-footer">
                <!-- <h5>{{ 'lang.commonComponents.FooterComponent.support' | translate }}</h5> -->
                <div class="right-top-footer-link">
                  <!-- <a href="#"> {{ 'lang.commonComponents.FooterComponent.help' | translate }}</a> -->
                  <!-- <a routerLink="/faq" *showIfHasFeature="{ feature: 'footer.faqLink' }">FAQ </a> -->
                  <!-- <a href="#"> {{ 'lang.commonComponents.FooterComponent.contact' | translate }}</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="second-footer d-flex">
              <div class="left-top-footer-link">
                <!-- <a href="#">{{ 'lang.commonComponents.FooterComponent.termsOfUse' | translate }}</a>
                <a href="#">{{ 'lang.commonComponents.FooterComponent.privacyPolicy' | translate }} </a>
                <a href="#">{{ 'lang.commonComponents.FooterComponent.cookiePolicy' | translate }} </a>
                <a href="#">&copy; Capgemini 2020 </a> -->
              </div>
              <div class="ml-auto right-top-footer-link">
                <!-- <label for="">{{ 'lang.commonComponents.FooterComponent.fontSize' | translate }}</label>
                <span (click)="IncreaseFontSize('0')" class="tiny"> A</span>
                <span (click)="IncreaseFontSize('2')" class="medium"> A</span>
                <span (click)="IncreaseFontSize('4')" class="lagre"> A</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isAuthenticated">
  <div class="footer-container">
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="second-footer d-flex">
              <div class="left-top-footer-link">
                <!-- <a href="#">{{ 'lang.commonComponents.FooterComponent.termsOfUse' | translate }}</a>
                <a href="#">{{ 'lang.commonComponents.FooterComponent.privacyPolicy' | translate }} </a>
                <a href="#">{{ 'lang.commonComponents.FooterComponent.cookiePolicy' | translate }} </a>
                <a href="#">&copy; Capgemini 2020 </a> -->
              </div>
              <div class="ml-auto right-top-footer-link">
                <div>
                  <!-- <label for="">{{ 'lang.commonComponents.FooterComponent.support' | translate }}</label>
                  <a href="#"> {{ 'lang.commonComponents.FooterComponent.help' | translate }}</a> -->
                  <!-- <a href="#">FAQ </a> -->
                  <!-- <a href="#"> {{ 'lang.commonComponents.FooterComponent.contact' | translate }}</a> -->
                </div>
                <div class="mr-auto right-top-footer-link">
                  <!-- <label for="">{{ 'lang.commonComponents.FooterComponent.fontSize' | translate }}</label>
                  <span (click)="IncreaseFontSize('0')" class="tiny"> A</span>
                  <span (click)="IncreaseFontSize('2')" class="medium"> A</span>
                  <span (click)="IncreaseFontSize('4')" class="lagre"> A</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
